import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: { padding: 30, fontFamily: 'Helvetica', fontSize: 10 },
  header: { backgroundColor: '#1565C0', color: '#ffffff', padding: 15, marginBottom: 20 },
  headerTitle: { fontSize: 18, fontWeight: 'bold' },
  headerSubtitle: { fontSize: 10, opacity: 0.9, marginTop: 4 },
  statsRow: { flexDirection: 'row', marginBottom: 20, gap: 10 },
  statBox: { flex: 1, border: '1px solid #e0e0e0', padding: 10, backgroundColor: '#f5f5f5', textAlign: 'center' },
  statValue: { fontSize: 16, fontWeight: 'bold', marginBottom: 2 },
  statLabel: { fontSize: 8, color: '#666666' },
  table: { marginBottom: 20 },
  tableHeader: { flexDirection: 'row', backgroundColor: '#e3f2fd', borderBottom: '2px solid #1565C0' },
  tableRow: { flexDirection: 'row', borderBottom: '1px solid #e0e0e0' },
  tableRowAlt: { flexDirection: 'row', borderBottom: '1px solid #e0e0e0', backgroundColor: '#fafafa' },
  cell: { padding: 8 },
  cellAwb: { width: 80 },
  cellFecha: { width: 70 },
  cellDestino: { width: 50 },
  cellEquipo: { width: 80 },
  cellNum: { width: 50, textAlign: 'center' },
  cellPeso: { width: 70, textAlign: 'right' },
  cellEstado: { width: 50, textAlign: 'center' },
  headerCell: { fontWeight: 'bold', fontSize: 9 },
  footer: { position: 'absolute', bottom: 30, left: 30, right: 30, borderTop: '1px solid #e0e0e0', paddingTop: 10, flexDirection: 'row', justifyContent: 'space-between', fontSize: 8, color: '#666666' },
});

const ReporteVuelosPDF = ({ data, filters }) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Text style={styles.headerTitle}>Reporte de Vuelos</Text>
          <Text style={styles.headerSubtitle}>
            Período: {filters.fecha_inicio} al {filters.fecha_fin}
          </Text>
        </View>

        <View style={styles.statsRow}>
          <View style={styles.statBox}>
            <Text style={styles.statValue}>{data.resumen.total_vuelos}</Text>
            <Text style={styles.statLabel}>TOTAL VUELOS</Text>
          </View>
          <View style={styles.statBox}>
            <Text style={styles.statValue}>{data.resumen.vuelos_cerrados}</Text>
            <Text style={styles.statLabel}>CERRADOS</Text>
          </View>
          <View style={styles.statBox}>
            <Text style={styles.statValue}>{data.resumen.vuelos_abiertos}</Text>
            <Text style={styles.statLabel}>ABIERTOS</Text>
          </View>
          <View style={styles.statBox}>
            <Text style={styles.statValue}>{data.resumen.total_pallets}</Text>
            <Text style={styles.statLabel}>PALLETS</Text>
          </View>
          <View style={styles.statBox}>
            <Text style={styles.statValue}>{(data.resumen.peso_total / 1000).toFixed(1)}t</Text>
            <Text style={styles.statLabel}>PESO TOTAL</Text>
          </View>
        </View>

        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <Text style={[styles.cell, styles.cellAwb, styles.headerCell]}>AWB</Text>
            <Text style={[styles.cell, styles.cellFecha, styles.headerCell]}>FECHA</Text>
            <Text style={[styles.cell, styles.cellDestino, styles.headerCell]}>DEST</Text>
            <Text style={[styles.cell, styles.cellEquipo, styles.headerCell]}>EQUIPO</Text>
            <Text style={[styles.cell, styles.cellNum, styles.headerCell]}>PALLETS</Text>
            <Text style={[styles.cell, styles.cellPeso, styles.headerCell]}>PESO (kg)</Text>
            <Text style={[styles.cell, styles.cellEstado, styles.headerCell]}>ESTADO</Text>
          </View>
          {data.vuelos.slice(0, 40).map((v, idx) => (
            <View key={v.awb} style={idx % 2 === 0 ? styles.tableRow : styles.tableRowAlt}>
              <Text style={[styles.cell, styles.cellAwb]}>{v.awb}</Text>
              <Text style={[styles.cell, styles.cellFecha]}>{new Date(v.fecha).toLocaleDateString()}</Text>
              <Text style={[styles.cell, styles.cellDestino]}>{v.destino}</Text>
              <Text style={[styles.cell, styles.cellEquipo]}>{v.equipo}</Text>
              <Text style={[styles.cell, styles.cellNum]}>{v.total_pallets}</Text>
              <Text style={[styles.cell, styles.cellPeso]}>{(v.peso_total || 0).toLocaleString()}</Text>
              <Text style={[styles.cell, styles.cellEstado]}>{v.cerrado ? 'Cerrado' : 'Abierto'}</Text>
            </View>
          ))}
        </View>

        <View style={styles.footer}>
          <Text>Generado: {new Date().toLocaleString()}</Text>
          <Text>Pallet Control - Sistema de Gestión de Carga</Text>
        </View>
      </Page>
    </Document>
  );
};

export default ReporteVuelosPDF;

